import * as Settings from '../services/Settings'

export const RECEIVE_SETTING = 'RECEIVE_SETTING'

function receiveSetting(state, setting) {
  return {
    type: RECEIVE_SETTING,
    setting
  }
}

export const fetchSetting = (key) => (dispatch, getState) => {
  const state = getState()
  Settings.getSetting(key).then((data) => dispatch(receiveSetting(state, data)))
}
